<template>
    <v-dialog v-model="visible" persistent max-width="100%">
        <div>
            <v-card>
                <v-container background="dark">
                    <v-row class="text-center mt-10 pt-10">
                        <v-col>
                            <v-card-title class="headline">
                                This feature requires subscription.
                                <v-spacer></v-spacer>
                                <v-btn icon @click="close()" class="close-btn">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-btn-toggle class="my-5" v-model="toggle_price" rounded>
                                <v-btn v-for="item in currency" :key="item.slug" outlined color="cyan accent-3"
                                    @click="changeCurrency(item.slug)">
                                    {{ item.symbol + " " + item.name }}
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-space-around">
                        <v-col cols="12" lg="4" md="6" sm="6" v-for="(pricing, index) in pricings" :key="pricing.title"
                            class="text-center">
                            <div class="pricing">
                                <v-row>
                                    <v-col>
                                        <h2 class="white--text mb-2">{{ pricing.title }}</h2>
                                        <p class="mb-2 overline">
                                            {{ pricing.subtext }}
                                        </p>
                                        <!-- Sub Dynamic -->
                                        <!-- <h1>{{ pricing.price[selected_price[index]].prefix }}</h1> -->
                                        <h1 class="mt-0">
                                            <span class="subtitle-1"
                                                v-html="pricing.price[selected_price[index]].prefix">

                                            </span>
                                            {{ pricing.price[selected_price[index]].text }}
                                            <span class="subtitle-2">
                                                {{ pricing.price[selected_price[index]].postfix }}
                                            </span>
                                        </h1>
                                        <v-btn-toggle v-if="pricing.price.length > 1" v-model="selected_price[index]"
                                            class="toggle-prices mt-4">
                                            <v-btn small color="cyan accent-3" outlined
                                                v-for="(price, id) in pricing.price" :key="id"
                                                :disabled="selected_price[index] == id" class="text-capitalize">
                                                {{ price.postfix }}
                                            </v-btn>
                                        </v-btn-toggle>
                                        <p class="mt-5">
                                            {{ pricing.price[selected_price[index]].message }}
                                        </p>
                                        <!-- Sub Dynamic-Ends -->
                                        <v-divider class="mb-10"></v-divider>
                                        <div v-if="pricing.maintainance">
                                            <v-img aspect-ratio="1" :src="require('@/assets/img/under_development.svg')"
                                                height="300" contain></v-img>
                                        </div>
                                        <ul class="price-list"
                                            :class="[$vuetify.breakpoint.smAndDown ? 'mx-2' : 'mx-12']">
                                            <li v-for="(item, i) of pricing.features" :key="i + 'pricing.features'">
                                                <a color="#6a7a7a" @click="feature_explorer(item)">{{
                                                    item.text
                                                    }}</a>
                                                <!-- {{ item }} -->
                                            </li>
                                        </ul>
                                        <v-btn class="mt-4 button" outlined color="cyan accent-3" large target="_blank"
                                            :href="subscribe_from">
                                            {{ pricing.checkout }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <v-dialog v-model="feature_img_dialogue" transition="dialog-bottom-transition" fullscreen
                class="overflow-y-hidden plan_dialogue mx-0">
                <v-card color="#000000 " class="overflow-y-hidden">
                    <v-toolbar dark color="#000000" height="120">
                        <v-list-item-content class="py-0 text-center">
                            <v-list-item-title class="font-weight-bold title"
                                :class="[$vuetify.breakpoint.smAndDown ? 'subtitle-2' : '']">{{
                                    selected_feature_img.text }}
                            </v-list-item-title>
                            <p class="pt-2" :class="[$vuetify.breakpoint.smAndDown ? 'mobile-text' : '']">
                                {{ selected_feature_img.subtitle }}
                            </p>
                        </v-list-item-content>

                        <v-btn icon @click="feature_img_dialogue = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="px-0 py-0">
                        {{ selected_feature_img.img }}
                        <v-img max-height="700" :src="selected_feature_img.img && require(selected_feature_img.img)"
                            contain></v-img>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </v-dialog>
</template>

<script>
import PriceData from "../assets/prices";

export default {
    name: 'PaywallPopup',
    data() {
        return {
            subscribe_from: process.env.VUE_APP_CARD_BASE_URL + '/prices',
            visible: false,
            trial: false,
            newValue: "",
            alert: false,
            checkout_invoice: false,
            alert_text: "",
            subscription_status: "",
            message: "",
            loading: false,
            drawer: false,
            user_slider: 20,
            cards: null,
            userDetails: false,
            username: "",
            price_slug: "",
            session_id: "",
            plan_name: "",
            invoice_number: "",
            invoice_url: "",
            plan_currency_sign: "",
            total_amount: "",
            payment_intent: null,
            subscription_start_date: "",
            subscription_end_date: "",
            plan_subscription: "",
            plan_abbreviation: "",
            plan_trial_days: "",
            available_balance: "",
            tax: "",
            notes: "",
            subtotal: "",
            customer_email: "",
            total: "",
            toggle_price: null,
            currency: PriceData.currency,
            usd_pricings: PriceData.usd_pricings,
            inr_pricings: PriceData.inr_pricings,
            compare: PriceData.compare,
            pricings: [],
            show_price: "usd_pricings",
            selected_price: {
                0: 0,
                1: 0,
                2: 0,
                3: 0,
            },
            login_checkout: false,
            feature_img_dialogue: false,
            selected_feature_img: {},
        };
    },
    watch: {
        selected_price: {
            handler(val) {
                console.log(val);
            },
            deep: true,
        },
    },
    beforeMount() {
        this.username = this.$cookies.get("user");
        fetch('https://get.geojs.io/v1/ip/country.json')
            .then(response => response.json())
            .then((resp) => {
                console.log(resp);
                if (resp.country == "IN") this.show_price = "inr_pricings";
                else this.show_price = "usd_pricings";
                this.pricings = this[this.show_price];
            }).catch((err) => {
                console.log("Error : " + JSON.stringify(err));
                this.show_price = "usd_pricings";
            });
    },
    methods: {
        open() {
            this.visible = true;
        },
        close() {
            this.visible = false;
        },
        upgrade() {
            // Redirect to the upgrade page or handle the upgrade process
            this.visible = false;
            this.$router.push({ name: 'Upgrade' }); // Assuming you have an Upgrade route
        },
        changeCurrency(slug) {
            console.log("Changing to " + slug);
            this.pricings = this[slug];
        },
        feature_explorer(item) {
            console.log(item);
            if (item.img !== null) {
                this.feature_img_dialogue = true;
                this.selected_feature_img = '@/assets/' + item.img;
            }
        },
    }
};
</script>

<style scoped>
.v-card__subtitle {
    color: var(--v-secondary-lighten1) !important;
}

.theme--dark.v-application a:hover {
    color: #68e6fb !important;
}

.theme--dark.v-application a {
    color: #6a7a7a !important;
}

.element.style {
    background-color: rgb(0 10 14) !important;
    border-color: rgb(33, 33, 33) !important;
}

@media (min-width: 1904px) {
    .container {
        max-width: 1600px !important;
    }
}

.theme--dark.v-list {
    background: #00000000 !important;
    color: #ffffff;
}

.v-application .primary--text {
    color: #68e6fb !important;
    caret-color: #68e6fb !important;
}

.pricing {
    background: rgb(14, 22, 27);
    background: linear-gradient(180deg,
            rgba(14, 22, 27, 1) 0%,
            rgba(14, 22, 27, 0) 100%);
    padding: 32px;
    border-radius: 25px;
}

/* #68E6FB */

.rounded .v-image__image--cover {
    border-radius: 15px !important;
}

.text-box {
    color: #68e6fb;
    border-radius: 15px;
    border-color: #000000;
}

.price-list {
    list-style-type: none;
}

.price-list li {
    text-align: left;
    margin: 16px 0 !important;
    font-size: large;
}

@media screen and (min-width: 1400px) {}

@media screen and (min-width: 1600px) {}

@media screen and (min-width: 1900px) {}

.price-list li::before {
    position: relative;
    top: 4px;
    margin-right: 10px;
    content: url("@/assets/img/ic_right.svg");
}

.available {
    content: url("@/assets/img/ic_right.svg");
}

.v-btn--disabled {
    background-color: #000000 !important;
}

.rating {
    background: rgb(14, 22, 27);
    background: linear-gradient(180deg,
            rgba(14, 22, 27, 1) 0%,
            rgba(14, 22, 27, 0) 100%);
    padding: 32px;
    border-radius: 25px;
}

.rating {
    width: 300px;
    min-height: 250px;
    text-align: center;
}

.plan_dialogue {
    max-height: 100% !important;
}

.mobile-text {
    font-size: 14px;
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
}
</style>